import React from "react";
import { MarkdownPageContext } from "@utils/MarkdownUtils";
import { DeepNonNullable } from "ts-essentials";
import { ImageRender } from "./ImageRender";
import { SocialProofBanner } from "@ui/SocialProofBanner";

import Button from "@ui/Button";
import { useModal } from "@ui/Modals/ModalContext";

export type HeroDataType = {
  title: string;
  subtitle: string;
  emailInputButtonText: string;
  buttonSubtitle: string;
  image: DeepNonNullable<Queries.LandingPageDataQuery>["strapiFrontpage"]["hero"]["image"];
};

const Hero = ({
  title,
  image,
  subtitle,
  emailInputButtonText,
  buttonSubtitle,
}: HeroDataType) => {
  const { showSignUpModal } = useModal();

  return (
    <div className="mx-6 mt-0 max-w-full md:mx-4">
      <div className="flex flex-col items-start bg-accuRankerPurple-900 text-center md:w-full md:items-center md:py-20">
        <div className="grid min-h-[460px] grid-cols-9 gap-4">
          <div className="col-span-9 my-auto md:col-span-5">
            <div id="title" className="text-center text-white">
              <h1>
                <MarkdownPageContext options={{ forceInline: true }}>
                  {title}
                </MarkdownPageContext>
              </h1>
            </div>
            <div id="subtitle" className="mt-4 text-white">
              <h2 className="text-base font-medium">{subtitle}</h2>
            </div>

            <div className="mx-auto flex flex-col items-start items-center gap-2 md:w-10/12">
              <Button
                armaTag="hero-start-trial-button"
                color="green"
                onClick={() => {
                  showSignUpModal();
                  window.gtag?.("event", "sign_up_step_1", {
                    button_text: emailInputButtonText,
                  });
                }}
                padding="small"
                className="h-[48px] pr-2 pl-2"
                id="hero-start-trial-button"
              >
                {emailInputButtonText}
              </Button>
              <div className="mb-4 text-xs text-white">{buttonSubtitle}</div>
              <SocialProofBanner />
            </div>
          </div>
          <div className="col-span-9 my-auto hidden md:col-span-4 md:block">
            <ImageRender image={image} className="mx-auto shadow-xl" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Hero;
